import { Box, Button, Grid, Typography } from '@material-ui/core';
import { Backdrop } from '@room-match/shared-ui-components';
import { FrontLayout } from 'components';
import { useHistory, useParams } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { projectService } from 'shared/services/projectService';
import { getMobileOperatingSystem } from 'shared/utils/common';
import { ls } from 'shared/utils/ls';
import appstore from './appstore.png';
import playstore from './playstore.png';

const { getSingleProject } = projectService();

function NewTalent() {
  const { projectId, option } = useParams() as { projectId: string; option: string };
  const { data, isLoading } = getSingleProject(projectId);
  const history = useHistory();

  const { setLS } = ls();

  if (isLoading) return <Backdrop isLoading={true} />;

  const OS = getMobileOperatingSystem();

  console.log('Current OS', OS);

  return (
    <FrontLayout type="login" newTalent containerWidth={500}>
      <Typography style={{ fontSize: 20, textAlign: 'center', fontWeight: 500 }}>
        {option === 'check-in'
          ? `Hello, You have been requested by ${data?.data.attributes.company_name} to use Casting App to check in for your audition today.`
          : `Hello, You have been requested to use Casting App to submit your self tape by ${data?.data.attributes.company_name}.`}
      </Typography>
      {option === 'check-in' ? (
        <Box style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography style={{ fontSize: 14, textAlign: 'center', marginTop: 29 }}>
            Download the app, select Check-in and scan the QR code.
          </Typography>
          <Grid
            container
            style={{ width: '100%', alignItems: 'center', marginTop: 30, display: 'flex', flexDirection: 'column' }}
          >
            {OS === 'unknown' ? (
              <>
                <Grid item>
                  <Button
                    style={{ backgroundColor: 'black', borderRadius: 10, marginBottom: 10 }}
                    onClick={() =>
                      window.open(
                        'https://apps.apple.com/ph/app/casting-app-for-talent/id1634450341',
                        '_blank',
                        'noopener,noreferrer',
                      )
                    }
                  >
                    <img src={playstore} style={{ width: 200, height: 70, objectFit: 'contain' }} />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    style={{ backgroundColor: 'black', borderRadius: 10 }}
                    onClick={() =>
                      window.open(
                        'https://play.google.com/store/apps/details?id=com.castingapp.talent',
                        '_blank',
                        'noopener,noreferrer',
                      )
                    }
                  >
                    <img src={appstore} style={{ width: 200, height: 70, objectFit: 'cover' }} />
                  </Button>
                </Grid>{' '}
              </>
            ) : OS === 'iOS' ? (
              <Grid item>
                <Button
                  style={{ backgroundColor: 'black', borderRadius: 10, marginBottom: 10 }}
                  onClick={() =>
                    window.open(
                      'https://apps.apple.com/ph/app/casting-app-for-talent/id1634450341',
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }
                >
                  <img src={playstore} style={{ width: 200, height: 70, objectFit: 'contain' }} />
                </Button>
              </Grid>
            ) : (
              <Grid item>
                <Button
                  style={{ backgroundColor: 'black', borderRadius: 10 }}
                  onClick={() =>
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.castingapp.talent',
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }
                >
                  <img src={appstore} style={{ width: 200, height: 70, objectFit: 'cover' }} />
                </Button>
              </Grid>
            )}
          </Grid>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 500, marginTop: 30 }}>
            Note: This can also be done on the web by clicking the following link:
          </Typography>
          <Button
            style={{
              alignSelf: 'center',
              backgroundColor: COLORS.PRIMARY,
              padding: '15px 50px',
              borderRadius: 10,
              marginTop: 30,
            }}
            onClick={() => {
              setLS('projectId', projectId);
              setLS('option', option);
              history.push(`/signup`);
            }}
          >
            <Typography style={{ fontSize: 18 }}>Continue on Web</Typography>
          </Button>
          {/* <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 500, marginTop: 60 }}>
            Should you choose to download the app, here are the steps for you to complete:
          </Typography>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`a) Download Talent App`}
          </Typography>
          <Grid container style={{ width: '100%', justifyContent: 'center', marginTop: 30, display: 'flex' }}>
            <Grid item>
              <Button
                style={{ backgroundColor: 'black', borderRadius: 10, marginRight: 10 }}
                onClick={() =>
                  window.open(
                    'https://apps.apple.com/ph/app/casting-app-for-talent/id1634450341',
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <img src={playstore} style={{ width: 200, height: 70, objectFit: 'contain' }} />
              </Button>
            </Grid>
            <Grid item>
              <Button
                style={{ backgroundColor: 'black', borderRadius: 10 }}
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.castingapp.talent',
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <img src={appstore} style={{ width: 200, height: 70, objectFit: 'cover' }} />
              </Button>
            </Grid>
          </Grid> */}
          {/* <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`a) Register An Account if you don't have one yet for Casting App`}
          </Typography>
          <Box style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: 31 }}>
            <img src={b} style={{ width: 200, borderRadius: 12 }} />
          </Box>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`b) Once Complete Select Check-In on the dashboard`}
          </Typography>
          <Box style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: 31 }}>
            <img src={c} style={{ width: 200, borderRadius: 12 }} />
          </Box>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`c) Scan the QR code or type it to check-in for your project`}
          </Typography>
          <Box style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: 31 }}>
            <img src={d} style={{ width: 200, borderRadius: 12 }} />
          </Box>
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 13 }}>
              The Project is
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                textAlign: 'center',
                fontWeight: 600,
                marginTop: 13,
                color: COLORS.PRIMARY,
                marginLeft: 4,
              }}
            >
              {data?.data.attributes?.name}
            </Typography>
          </Box>
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: 25, textAlign: 'center', fontWeight: 600, marginTop: 0 }}>Code:</Typography>
            <Typography
              style={{
                fontSize: 25,
                textAlign: 'center',
                fontWeight: 600,
                marginTop: 0,
                color: COLORS.PRIMARY,
                marginLeft: 5,
              }}
            >
              {data?.data.attributes.slug}
            </Typography>
          </Box>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`d) This will load the project and role information for your audition.`}
          </Typography>
          <Box style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: 31 }}>
            <img src={e} style={{ width: 200, borderRadius: 12 }} />
          </Box>
          <Typography style={{ fontSize: 16, textAlign: 'center', fontWeight: 600, marginTop: 30 }}>
            {`e) Please complete the required steps to finish checking-in.`}
          </Typography>
          <Box style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: 31 }}>
            <img src={f} style={{ width: 200, borderRadius: 12 }} />
          </Box> */}
        </Box>
      ) : (
        <Box
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginTop: 60,
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Button
            style={{ alignSelf: 'center', backgroundColor: COLORS.PRIMARY, padding: '15px 50px', borderRadius: 10 }}
            onClick={() => {
              setLS('projectId', projectId);
              setLS('option', option);
              history.push(`/signup`);
            }}
          >
            <Typography style={{ fontSize: 18 }}>Click Here to Begin</Typography>
          </Button>
          <Typography style={{ fontSize: 20, marginTop: 40, textAlign: 'center' }}>
            If requested, enter the following details:
          </Typography>
          <Box
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', marginTop: 27 }}
          >
            <Typography style={{ fontSize: 25 }}> Code: </Typography>
            <Typography style={{ fontSize: 25, marginLeft: 5, color: COLORS.PRIMARY }}>
              {data?.data.attributes.slug}
            </Typography>
          </Box>
          <Typography
            style={{ fontSize: 14, textAlign: 'center' }}
          >{`(The Project is ${data?.data.attributes?.name})`}</Typography>
        </Box>
      )}
    </FrontLayout>
  );
}

export default NewTalent;
